import React, { useState } from 'react';
import DrawerForm from 'components/DrawerForm';
import { Input, Form, Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import globalMessages from 'translations/messages';

const EditGlobalFilterDrawer = ({
  open,
  globalFilter,
  onSubmit,
  onRemove,
  onCancel,
  onCreate,
  onDuplicate,
}) => {
  const [creating, setCreating] = useState(false);
  const [duplicating, setDuplicating] = useState(false);

  const handleCreate = async () => {
    setCreating(true);
    try {
      await onCreate();
    } finally {
      setCreating(false);
    }
  };

  const handleDuplicate = async () => {
    setDuplicating(true);
    try {
      await onDuplicate();
    } finally {
      setDuplicating(false);
    }
  };

  return (
    <DrawerForm
      open={open}
      onSubmit={onSubmit}
      onCancel={onCancel}
      title="Edit global filter"
      initialValues={globalFilter}
      formReset={globalFilter?.id}
      onRemove={globalFilter?.id ? onRemove : undefined}
      footerStart={(
        <>
          <Button onClick={handleCreate} loading={creating}>
            New filter
          </Button>
          {globalFilter?.id && (
            <Button onClick={handleDuplicate} loading={duplicating}>
              <FormattedMessage {...globalMessages.duplicate} />
            </Button>
          )}
        </>
      )}
    >
      <Form.Item label="Title" name="title">
        <Input />
      </Form.Item>
    </DrawerForm>
  );
};

export default EditGlobalFilterDrawer;
